import { Type } from "class-transformer";

export class InstallationItemModel {
  code: string = "";
  name: string = "";
  image: string = "";
  requestAmount: number = 0;
  actualAmount: number = 0;
  installedAmount: number = 0;
  damagedAmount: number = 0;
  damagedReason: string = "";
  lostAmount: number = 0;
  lostReason: string = "";
  remark: string = "";
  price: number = 0;
  actualPrice: number = 0;
  delFlag: boolean = false;
}

export class InstallationSectionModel {
  @Type(() => InstallationItemModel)
  items: InstallationItemModel[] = [];

  imgUrls: string[] = [];
}

export class EventDetailInstallModel {
  eventId: number = 0;
  eventStatusCode: string = "";
  eventStatusName: string = "";
  isConfirm: boolean = false;

  @Type(() => InstallationSectionModel)
  equipment: InstallationSectionModel = new InstallationSectionModel();

  @Type(() => InstallationSectionModel)
  poppos: InstallationSectionModel = new InstallationSectionModel();

  @Type(() => InstallationSectionModel)
  serving: InstallationSectionModel = new InstallationSectionModel();

  signatureImgId: string = "";

  eventName?: string;
  customerName?: string;
  customerContact?: string;
  customerEmail?: string;
}
